module.exports = __webpack_public_path__ + "media/Audio18_i.aabcfd6b.wav";